import loadable from '@loadable/component';

import { IComparisonNotification } from '../../state/offersComparison/comparisonNotification';

export const ComparisonNotificationLoadableContainer = loadable<{ notification: IComparisonNotification }>(
  () => import('./ComparisonNotificationContainer'),
);
